import React, { useEffect, useState } from "react";
import ProgressBar from "@ramonak/react-progress-bar";
import Text from "../../component/text/Text";
import "./PasswordStrengthBar.css";
import Tick from "./img/tick.svg";
import TickFilled from "./img/tickFilled.svg";

const PasswordStrengthBar = ({ password, onStrengthChange, module }) => {
  const [strengthValue, setStrengthValue] = useState(0);
  const [strengthLabel, setStrengthLabel] = useState("");
  const [criteria, setCriteria] = useState({
    length: false,
    number: false,
    uppercase: false,
    specialChar: false,
  });

  const updateStrengthBar = (value, color) => {
    document.documentElement.style.setProperty(
      "--strength-bar-width",
      `${value}%`
    );
    document.documentElement.style.setProperty("--strength-bar-color", color);
  };

  useEffect(() => {
    if (password) {
      const hasLength = password.length >= 8;
      const hasNumber = /\d/.test(password);
      const hasUppercase = /[A-Z]/.test(password);
      const hasSpecialChar = /[!@#$%^&*(),.?]/.test(password);

      // Count how many conditions are met (excluding length)
      const strengthCount = [hasNumber, hasUppercase, hasSpecialChar].filter(
        Boolean
      ).length;

      let strengthValue = 0;
      let strengthLabel = "Too weak";
      let color = "#B42318"; // Default color for "Too weak"

      if (!hasLength || strengthCount === 0) {
        strengthValue = 15; // Too weak
      } else if (strengthCount === 1) {
        strengthValue = 35; // Weak
        strengthLabel = "Weak";
      } else if (strengthCount === 2) {
        strengthValue = 60; // Medium
        strengthLabel = "Medium";
        color = "#F79009";
      } else if (strengthCount === 3) {
        strengthValue = 100; // Strong
        strengthLabel = "Strong";
        color = "#12B76A";
      }

      setStrengthValue(strengthValue);
      setStrengthLabel(strengthLabel);
      updateStrengthBar(strengthValue, color);
      onStrengthChange(strengthValue);

      setCriteria({
        length: hasLength,
        number: hasNumber,
        uppercase: hasUppercase,
        specialChar: hasSpecialChar,
      });
    } else {
      setStrengthValue(0);
      setStrengthLabel("");
      onStrengthChange(0);
      setCriteria({
        length: false,
        number: false,
        uppercase: false,
        specialChar: false,
      });
    }
  }, [password]);

  return (
    <>
      {password && (
        <>
          <ProgressBar
            completed={strengthValue}
            className="wrapperBar"
            barContainerClassName="containerBar"
            completedClassName="barCompletedBar"
            isLabelVisible={false}
            animateOnRender
          />
          <Text
            size="0.875rem"
            color="#344054"
            weight="500"
            align="right"
            text={strengthLabel}
          />

          <ul
            className={`password-criteria ${
              module === "signup" ? "signup-grid" : ""
            }`}
          >
            <li className={criteria.length ? "met" : ""}>
              <img
                src={criteria.length ? TickFilled : Tick}
                alt={criteria.length ? "Met" : "Not Met"}
              />
              <Text
                size={"0.875rem"}
                color="#344054"
                weight="400"
                text="At least 8 characters"
              />
            </li>
            <li className={criteria.uppercase ? "met" : ""}>
              <img
                src={criteria.uppercase ? TickFilled : Tick}
                alt={criteria.uppercase ? "Met" : "Not Met"}
              />
              <Text
                size={"0.875rem"}
                color="#344054"
                weight="400"
                text="Contains an uppercase letter"
              />
            </li>
            <li className={criteria.number ? "met" : ""}>
              <img
                src={criteria.number ? TickFilled : Tick}
                alt={criteria.number ? "Met" : "Not Met"}
              />
              <Text
                size={"0.875rem"}
                color="#344054"
                weight="400"
                text="Contains a number"
              />
            </li>
            <li className={criteria.specialChar ? "met" : ""}>
              <img
                src={criteria.specialChar ? TickFilled : Tick}
                alt={criteria.specialChar ? "Met" : "Not Met"}
              />
              <Text
                size={"0.875rem"}
                color="#344054"
                weight="400"
                text="Contains a special character"
              />
            </li>
          </ul>
        </>
      )}
    </>
  );
};

export default PasswordStrengthBar;
